import React from 'react';
import { BUSINESS } from '@/lib/site';

export default function JsonLd() {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: BUSINESS.name,
    image: window.location.origin + '/generated/training-facility.png',
    address: {
      '@type': 'PostalAddress',
      streetAddress: BUSINESS.address.line1,
      addressLocality: BUSINESS.address.city,
      addressRegion: 'Auckland',
      postalCode: BUSINESS.address.postcode,
      addressCountry: 'NZ',
    },
    telephone: '+6492716565',
    email: BUSINESS.email,
    openingHours: 'Mo-Fr 08:00-16:00',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: String(BUSINESS.rating),
      reviewCount: String(BUSINESS.reviewCount),
    },
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
